namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogAdmDiagnostikaDokumentu extends GContentBase {
        private cnt: GContent;

        private getCnt(): GContent {
            if (this.cnt == null || this.cnt == undefined)
                this.cnt = this.createServiceContent("Gordic.Adm.WebControls.DialogAdmDiagnostikaDokumentu");
            return this.cnt;
        }

        onContentReady() {
            this.init();
        }

        private init() {
            this.createActions();
            this.createForm();
            this.createCommandbar();
        }

        private createForm() {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                name: "formPid",
                customClass: "formPid"
            })
            .addRow("jres:33000687").addField("gstringbox", { //RC 33000687 : Zadejte identifikátor dokumentu
                name: "dokumentSpis",
                flag: "required",
                validators: [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Ixs({ stopping: true })]
            }).addRow("jres:33000720").addField("gcheck", { //RC 33000720 : Automaticky odeslat diagnostiku dokumentu firmě Gordic
                name: "automaticSend",
                labelFromRow: "always",
                initialValue: true
            }) 
            $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private createActions() {
            this.actions.addRange({
                actOk: {
                    caption: "jres:33000243",
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.actOk();
                    }
                },
                actClose: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.close();
                    }
                }
            })
        }

        private actOk() {
            var formData = {};
            this.element.findForms("formPid").findFields().gfield("model", "collect", formData);
            this.beginOperation("jres:33000719") //RC 33000719 : Probíhá generování diagnostiky
            this.isl.AdmDiagnostikaDokumentu.getDiagnostika({ ixp: formData['dokumentSpis'], automaticSend: formData['automaticSend'] }).get().done((result) => {
                if (result != null && result != undefined) {
                    var date = new Date();
                    new GFile().download({
                        guid: result,
                        filename: "{0}_{1}.adl".format(
                            formData['dokumentSpis'],
                            "{0}{1}{2}{3}{4}{5}".format(
                                date.getFullYear(),
                                this.padWithLeadingZeros(date.getMonth() + 1),
                                this.padWithLeadingZeros(date.getDate()),
                                this.padWithLeadingZeros(date.getHours()),
                                this.padWithLeadingZeros(date.getMinutes()),
                                this.padWithLeadingZeros(date.getSeconds())
                            )
                        )
                    }).done(() => {
                        this.getCnt().fire("RemoveFile", { guid: result });
                    })
                }
            }).always(() => {
                this.endOperation();
                this.close();
            });
        }

        private createCommandbar() {
            this.commandBar(this.actions.createBar(["actClose*", "actOk*"]))
        }

        private padWithLeadingZeros(num: number) {
            return (num < 10) ? "0{0}".format(num.toString()) : num.toString() 
        }
    }
}